// utils/storage.ts

// 1. Detect if we are on localhost
const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';

// 2. Dynamic Configuration
// Prod: Share across subdomains (.workhorse.com.sg)
// Local: Share across ports (localhost) - leave domain undefined to default to host
const COOKIE_DOMAIN = isLocal ? undefined : '.workhorse.com.sg';

// Prod: Require HTTPS
// Local: Allow HTTP
const SECURE_FLAG = isLocal ? '' : 'Secure;';

// Helper to set a shared cookie
const setSharedCookie = (name: string, value: string, hours: number) => {
  const date = new Date();
  date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();

  // Base cookie string
  let cookieString = `${name}=${value};${expires};path=/;SameSite=Lax;${SECURE_FLAG}`;

  // Only append domain if we are NOT on localhost
  if (COOKIE_DOMAIN) {
    cookieString += `domain=${COOKIE_DOMAIN};`;
  }

  document.cookie = cookieString;
};

// Helper to get a cookie
const getCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// Helper to delete a cookie
const deleteCookie = (name: string) => {
  // To delete a cookie, you must match the domain exactly as it was set.
  const domainAttr = COOKIE_DOMAIN ? `domain=${COOKIE_DOMAIN};` : '';

  document.cookie = `${name}=; Max-Age=-99999999; ${domainAttr} path=/;`;
};

// --- EXPORTED FUNCTIONS ---

export const saveAuth = (token: string, user: any) => {
  // 1. Save Token
  setSharedCookie('sessionId', token, 1);
  setSharedCookie('token', token, 1);

  // 2. CRITICAL FIX: Save the Expiration Time (1 hour from now)
  // This matches the '1' hour you passed to setSharedCookie
  const expirationTime = Date.now() + (60 * 60 * 1000); 
  setSharedCookie('tokenExpiration', expirationTime.toString(), 1);

  // 3. Save User
  if (user) {
    setSharedCookie('user', encodeURIComponent(JSON.stringify(user)), 1);
  }
};

export const getSessionId = () => {
  return getCookie('sessionId') || getCookie('token');
};

export const saveSessionId = (sessionId: string) => {
  setSharedCookie('sessionId', sessionId, 1);
};

// utils/storage.ts

export const clearAuth = () => {
  // 1. Clear Cookies
  deleteCookie('sessionId');
  deleteCookie('token');
  deleteCookie('user');
  deleteCookie('tokenExpiration');
  localStorage.clear();
  sessionStorage.clear();

};

export const isTokenValid = () => {
  const expirationStr = getCookie('tokenExpiration');
  if (expirationStr) {
    const expiration = parseInt(expirationStr, 10);
    const now = Date.now();
    return now < expiration;
  }
};

export const getUser = () => {
  const userStr = getCookie('user');
  if (userStr) {
    try {
      return JSON.parse(decodeURIComponent(userStr));
    } catch (e) {
      return null;
    }
  }
  return null;
};